import * as styledComponents from 'styled-components'

import { theme } from './theme'

/*
  Media queries を簡略記述するヘルパー関数

  現状、公式ドキュメント掲載の方法がTypeScriptエコシステムとの
  親和性がそれほど高くなく煩雑なため、下記Issueにおいて
  提案されている手法でMedia queriesを定義するようにしています。
  
  詳細は下記リンクを参照してください
  https://github.com/styled-components/styled-components/issues/2303#issuecomment-480047731
*/

const mediaQuery = (min: number) => `@media (min-width: ${min}px)`

export const breakPoints = {
  sm: 553,
  md: 767,
  lg: 922,
  xl: 1200,
}

export const mq = {
  sm: mediaQuery(breakPoints.sm),
  md: mediaQuery(breakPoints.md),
  lg: mediaQuery(breakPoints.lg),
  xl: mediaQuery(breakPoints.xl),
}

export const {
  default: styled,
  css,
  createGlobalStyle,
  keyframes,
  ThemeProvider,
  withTheme,
} = styledComponents as styledComponents.ThemedStyledComponentsModule<
  typeof theme
>
